import { UserSessionsSection } from "./sections/sessions/UserSessionsSection";
import { useSettingsAcl } from "./lib/useSettingsAcl";
import { SettingsAccessDenied } from "./SettingsLayout";

export function SitzungenPage() {
  const acl = useSettingsAcl();

  if (acl.loading) return null;
  if (!acl.canSessions) return <SettingsAccessDenied />;

  return <UserSessionsSection />;
}
